import * as React from "react";

import { cn } from "../../utils";

const Input = ({
  className,
  type,
  ...props
}: React.ComponentProps<"input">) => {
  return (
    <input
      type={type}
      className={cn(
        "af-shadow-xs af-flex af-h-10 af-w-full af-min-w-0 af-rounded-md af-border af-border-input af-bg-background af-px-3 af-py-2 af-text-base af-outline-none af-transition-[color,box-shadow] selection:af-bg-primary selection:af-text-primary-foreground file:af-inline-flex file:af-border-0 file:af-bg-background file:af-text-sm file:af-font-medium file:af-text-foreground placeholder:af-text-muted-foreground focus-visible:af-ring-[2px] focus-visible:af-ring-ring focus-visible:af-ring-offset-1 disabled:af-pointer-events-none disabled:af-cursor-not-allowed disabled:af-opacity-50 md:af-text-sm [&::file-selector-button]:af-px-0",
        className,
      )}
      {...props}
    />
  );
};
Input.displayName = "Input";
export { Input };
